import Translation from "@Translation/components/Translation";
import React from "react";

function MTicketPopoverOverlay() {
    return (
        <span>
            <Translation translationKey="search_results.has_mticket"/>
        </span>
    )
}

export default MTicketPopoverOverlay